import { forwardRef, type HTMLAttributes } from 'react';
import cn from 'classnames';

import { StringXSmall } from '@/components/Typography/Typography';
import { Picture } from '@/components/ui/Picture/Picture';

import { Tile } from '../Tile/Tile';
import { TilesBg } from '../TilesBg/TilesBg';

import css from './styles.module.scss';

import starPng from '/img/icons/star-large.png';
import starWebp from '/img/icons/star-large.webp';

interface StarsTileProps extends HTMLAttributes<HTMLDivElement> {
  isActive?: boolean;
  isSuperGame?: boolean;
  value?: number;
  variant?: 'mini-game' | 'start' | 'default';
}

const StarsTile = forwardRef<HTMLDivElement, StarsTileProps>(
  ({ isSuperGame, value, variant, ...props }, ref) => {
    return (
      <Tile
        ref={ref}
        {...props}
        variant={props.isActive ? 'dark' : 'grey'}
        className={cn(props.className, 'flex items-center justify-center')}
      >
        {value === 0 && variant === 'mini-game' ? (
          <span
            className={cn(
              'font-black text-[2rem] text-[#FFF8D5] leading-none relative z-[2]',
              css.zeroShadow,
            )}
          >
            0
          </span>
        ) : (
          <div className="relative z-[2] w-[72%] h-[72%] flex">
            <Picture
              className="w-full h-full"
              img={starPng}
              webp={starWebp}
              alt="tgem"
            />
          </div>
        )}
        {!!value && (
          <div className={css.tileValue}>
            <StringXSmall weight="bold">{value}</StringXSmall>
          </div>
        )}
        <TilesBg
          className={cn(!props.isActive && '!top-0 !left-0 !w-full !h-full')}
          variant={
            props.isActive
              ? 'purple-active'
              : isSuperGame
                ? 'purple-fill'
                : 'purple'
          }
          withStarsBg={isSuperGame}
        />
      </Tile>
    );
  },
);

export { StarsTile };
